import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useStyledBlock, StyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type VideoProps = { url: string; aspectRatio?: "16/9" | "4/3" };

export function VideoBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<VideoProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Video URL</Label>
          <Input
            className="h-8 text-xs"
            value={props.url ?? ""}
            onChange={(e) => setProp((p) => { p.url = e.target.value; })}
            placeholder="YouTube or Vimeo URL"
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Aspect ratio</Label>
          <Select
            value={props.aspectRatio ?? "16/9"}
            onValueChange={(v) => setProp((p) => { p.aspectRatio = v as VideoProps["aspectRatio"]; })}
          >
            <SelectTrigger className="h-8 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="16/9">16:9</SelectItem>
              <SelectItem value="4/3">4:3</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBackground={false} />;
  }
  return null;
}
